
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import descriptor from './QBESavingDialogDescriptor.json'
export default defineComponent({
    name: 'olap-custom-view-save-dialog',
    components: { Card, Dropdown, KnValidationMessages },
    props: { propDataset: Object, scopeTypes: Array, categoryTypes: Array },
    computed: {
        qbeAdvancedSaving(): any {
            return (this.$store.state as any).user.functionalities.includes('QbeAdvancedSaving')
        }
    },
    data() {
        return {
            v$: useValidate() as any,
            dataset: {} as any,
            descriptor
        }
    },
    created() {
        this.dataset = this.propDataset
    },
    watch: {
        selectedDataset() {
            this.dataset = this.propDataset
        }
    },
    validations() {
        const catTypeRequired = (value) => {
            return this.dataset.scopeCd == 'USER' || value
        }
        const customValidators: ICustomValidatorMap = { 'cat-type-required': catTypeRequired }
        const validationObject = { dataset: createValidations('dataset', descriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {
        updateIdFromCd(optionsArray, fieldToUpdate, updatedField) {
            const selectedField = optionsArray.find((option) => option.VALUE_CD === updatedField)
            selectedField ? (this.dataset[fieldToUpdate] = selectedField.VALUE_ID) : ''
        }
    }
})
